import { Event } from '@adminModels';
import { PaginationMetadata } from '@shared';

export interface EventsState {
  events: Event[];
  loading: boolean;
  error: string | null;
  selectedEvent: Event | null;
  pagination: PaginationMetadata;
}

export const initialEventsState: EventsState = {
  events: [],
  loading: false,
  error: null,
  selectedEvent: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 0,
  },
};

